import { FunctionComponent } from 'react';
import styles from './ProgressChart.module.scss';

export type ProgressChartProps = {
  variant: 'chart';
  backgroundColor: string;
  percentComplete: number;
};

type FC = FunctionComponent<ProgressChartProps>;

const ProgressChart: FC = ({ variant, backgroundColor, percentComplete }: ProgressChartProps) => (
  <div className={[styles[variant]].join(' ')}>
    <div
      className={styles.filler}
      style={{ width: `${percentComplete || 0}%`, backgroundColor: `${backgroundColor}` }}
    />
  </div>
);

export default ProgressChart;
